import styled from 'styled-components';

export const Label = styled.label``;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  & label {
    margin: 0px;
    font-size: 1em;
    font-weight: bold;
    text-transform: uppercase;
    & span {
      color: red;
    }
  }
  & input {
    width: 95%;
    color: #009E0F;
    text-align: center;
    font-size: 2.1em;
    font-weight: bold;
    border: 1px solid gray;
    border-right: none;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    &:focus:-webkit-placeholder {
      color: transparent;
    }
    &:focus {
      outline: none;
      background-color: rgba(0, 128, 0, 0.115);
    }
  }
  & button {
    color: #fff;
    width: 50px;
    z-index: 2;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-left: none;
    border-top: 1px solid gray;
    border-right: 1px solid gray;
    border-bottom: 1px solid gray;
    background-color: #0095E8;
    :disabled,
    :disabled i {
      cursor: not-allowed;
      background-color: #e7e7e7;
      color: #666;
    }
    padding: 0px;
    &:focus {
      outline: none;
    }
    & i {
      color: #fff;
      font-size: 1.5em;
      padding: 0px;
    }
  }
`;

export const InputButtonGroup = styled.div`
  display: flex;
  width: 95%;
  height: 50px;
`;
